import styled from 'styled-components';

import {
  Image as SemanticImage,
  Modal as SemanticModal,
} from 'semantic-ui-react';

export const QuestionLabel = styled.h2`
  ${({ marginBottom }) => marginBottom && 'margin-bottom: 15px;'}
  color: ${({ theme }) => theme.text};
  user-select: text;
  padding-bottom: 25px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  word-wrap: break-word;
  margin-top: 15px;
`;

/**
 * Before you change this component,you need check functionality heatmap.js
 * because your change impact heatmap.js
 */
export const ImageDiv = styled.img`
  // apply opacity to image when clickConfirmation is active
  ${({ clickConfirmation }) => clickConfirmation && `
    filter: brightness(50%);
  `}
  max-width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const NotLoadedImage = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  width: 400px;
  height: 400px;
  border-radius: 4px;
  background-color: #f8f8f8;
  position: relative;
`;

export const Modal = styled(SemanticModal)`
  height: 100vh;
  width: 100vw;
  &.ui.modal {
    height: 70%;
    width: 70%;
    max-width: 1345px;
    max-height: 700px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 3%;
`;

// export const ImageContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 80%;
//   height: 80%;
// `;

export const ModalImage = styled(SemanticImage)`
  max-width: 100%;
  max-height: 100%;
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.color.link};
  text-decoration: none;
  cursor: pointer;
  font-weight: 400;
`;

export const ImageLabel = styled.div`
  ${({ marginBottom }) => marginBottom && 'margin-bottom: 15px;'}
  color: ${({ theme }) => theme.text};
  user-select: text;
  font-weight: 500;
  font-size: 0.9rem;
  padding-bottom: 25px;
`;
